import { inject, injectable } from 'inversify';
import { model_rule_unit_troop_full } from '@Api';
import { ModelRuleUnitTroop, TypeRule } from '@Models';
import { TYPES } from '@Types';
import { TypeLvlMapper } from './TypeLvlMapper';

@injectable()
export class ModelRuleUnitTroopMapper {
  @inject(TYPES.Mapper.TypeLvlMapper) private _typeLvlMapper!: TypeLvlMapper;

  public map(item: model_rule_unit_troop_full): ModelRuleUnitTroop {
    return {
      id: item.id,
      modelRuleId: item.model_rule_id,
      unitId: item.unit_id,
      troopId: item.troop_id,
      name: item.name ?? '',
      description: item.description ?? '',
      info: item.info,
      typeLvl: this._typeLvlMapper.map(item.type_lvl),
      isVisible: item.is_visible,
      typeRule: this.mapTypeRule(item.type_rule),
    } satisfies ModelRuleUnitTroop as ModelRuleUnitTroop;
  }

  public mapTypeRule(item: model_rule_unit_troop_full.type_rule): TypeRule {
    switch (item) {
      case model_rule_unit_troop_full.type_rule.EQUIPMENT:
        return TypeRule.Equipment;
    }
    return TypeRule.SpecialRule;
  }
}
